// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"225":"99c48340","283":"fc78693e","310":"4b910c72","470":"dea53f57","908":"fc78693e","994":"555b3738"}[chunkId] + ".css";
};